<template>
    <div class="field">
        <label class="label" v-if='label != ""'>{{ label }}</label>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Field',

    props: {
        label: {
            type: String,
            default: ''
        }
    }
};
</script>

<style>
</style>